import "../../styles/reports/reports.scss";
import React, { Component } from "react";

class HighlightedDetailTab extends Component {
  render() {
    return (
      <button className="highlightedDetailBody" onClick={this.props.functionCall}>
        <i className={`fa ${this.props.leftIcon} ${this.props.click ? "blueColorActive" : ""}`}></i>
        <p>
          {this.props.customerName}
          <span className={`${this.props.click ? "blueColorActive" : ""}`}>{this.props.generalName}</span>
        </p>
        <i className={`fa fa-caret-down ${this.props.click ? "blueColorActive" : ""}`}></i>
      </button>
    );
  }
}

export default HighlightedDetailTab;
